module.exports = __webpack_public_path__ + "img/Mathias.329d150c.png";